// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"143f6f7f","4":"5140fc1f","27":"ddf00e8e","99":"b70daa68","174":"db1821d9","216":"241e5164","272":"dadeca94","281":"2e01b32c","310":"a944b9c1","432":"0d457a7c","488":"32c3fafd","627":"9396d126","675":"b2b71221","778":"e47208ac"}[chunkId] + ".chunk.js";
};